<div class="error-container">
  <div class="text-container">
    <span class="heading">
      {{ 'rto.common.page_not_found_tellent.heading' | translate }}
    </span>
    <span class="error-code">
      {{ 'rto.common.page_not_found_tellent.error_code' | translate }}
    </span>
    <span class="description">
      {{ 'rto.common.page_not_found_tellent.description' | translate }}
    </span>
    <span
      class="support-note"
      [innerHTML]="'rto.common.page_not_found_tellent.support_note' | translate"
    ></span>

    <a rt-button variant="primary" class="homepage-button" [href]="tellentAuthUrl">
      {{ 'rto.common.page_not_found_tellent.go_to_homepage' | translate }}
    </a>
  </div>

  <div class="image-container">
    <img src="assets/images/not-found-tellent.svg" alt="" />
  </div>
</div>
